import { onMounted, onUnmounted, ref, type Ref } from 'vue'

// Refresh cadence for reactive relative-time labels (#1438) — a "just now" /
// "N min ago" string next to a chat bubble or card is only ever recomputed
// when *something else* forces the component to re-render, so a quiet
// conversation freezes the label until an unrelated prop change (or a manual
// page refresh) happens to trigger one.
export const NOW_TICK_MS = 30_000

// A `Date` ref that ticks on an interval while the owning component is
// mounted. Feed it into `formatDate(input, now.value)` (or reference `now`
// directly in a template, where refs auto-unwrap) so relative-time text
// stays live without polling any data.
export function useNow(intervalMs: number = NOW_TICK_MS): Ref<Date> {
  const now = ref(new Date())
  let timer: number | undefined
  onMounted(() => {
    timer = window.setInterval(() => {
      now.value = new Date()
    }, intervalMs)
  })
  onUnmounted(() => window.clearInterval(timer))
  return now
}
